// extracted by mini-css-extract-plugin
module.exports = {"h1":"ErrorDisplay_h1__3vff4","h2":"ErrorDisplay_h2__4rQoS","p":"ErrorDisplay_p__2wUkD"};